import {
  CustomizationFlagStatesV2,
  LocationFeatureV2,
} from 'models/location-feature.model';
import {
  UnifyMetricEvalCommonData,
  UnifyMetricEvalContext,
} from '../unify-metrics.types';
import { OfficeConfigurations } from 'redux/actions/customization/customization.action';
import { QueryClient } from 'react-query';
import { fetchSalesforceBundle } from '../queries/unify-handoff.queries';
import { fetchLocationFeatures } from 'components/customization-page-container/customization-page.queries';
import { VerticalEnum } from 'models/vertical-enum';

export const fetchLocationContextData = async ({
  locationId,
  locationName,
  verticalId,
  queryClient,
  ...rest
}: {
  locationId: string;
  locationName?: string;
  verticalId?: VerticalEnum;
  queryClient: QueryClient;
} & UnifyMetricEvalCommonData): Promise<UnifyMetricEvalContext> => {
  const [features, salesforceBundle] = await Promise.all([
    fetchLocationFeatures(queryClient, locationId),
    fetchSalesforceBundle(queryClient, locationId),
  ]);
  const officeConfigurations = deriveOfficeConfigurations(features);
  return {
    locationId,
    locationName,
    verticalId,
    queryClient,
    features,
    officeConfigurations,
    salesforceBundle,
    ...rest,
  };
};

export const deriveOfficeConfigurations = (
  features: LocationFeatureV2[]
): OfficeConfigurations => {
  const isIntegrated = features.some(
    (f) => f.name === 'Integrated' && f.state === CustomizationFlagStatesV2.ACTIVE
  );
  const hasChat = features.some(
    (f) => f.name === 'Chat' && f.state === CustomizationFlagStatesV2.ACTIVE
  );
  const isPhonesOnly = !isIntegrated && !hasChat;
  const isSoftwareOnly = features.some(
    (f) => f.name === 'Phone Home Icon' && f.state === CustomizationFlagStatesV2.HIDE
  );
  const hasPremiumFeatures = features.some(
    (f) => f.name === 'Fax' && f.state === CustomizationFlagStatesV2.ACTIVE
  );
  return { isIntegrated, isPhonesOnly, isSoftwareOnly, hasPremiumFeatures };
};
